export { useGetAdTypeParam } from './useGetAdTypeParam';
export { useGetJobIdParam } from './useGetJobIdParam';
